import gsap from "gsap";
import { MotionPathPlugin, CustomEase } from "gsap/all";
import DefaultBlock from "/scripts/default/block";

// Register Plugins
gsap.registerPlugin(MotionPathPlugin, CustomEase);

export default class ScrollPlugins extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			wrap: selector("#plugins-wrap"),
			back: selector("#plugins-back"),
			front: selector("#plugins-front"),
			path: selector("#plugins-path"),
			ball: selector("#plugins-ball"),
		};
		this.DOM = DOM;

		this.switchIndexes = this.switchIndexes.bind(this);

		this.defaults = {
			ease: CustomEase.create(
				"custom",
				"M0,0 C0.078,0.126 0.144,0.214 0.198,0.264 0.27,0.331 0.349,0.372 0.426,0.446 0.55,0.566 0.508,0.572 0.596,0.658 0.716,0.775 0.694,0.708 0.864,0.86 0.961,0.947 1,1 1,1 "
			),
			duration: 10,
		};

		this.tl = this.createTimeline();
	}

	ballAlongPath() {
		return gsap.to(this.DOM.ball, {
			motionPath: {
				path: this.DOM.path[0],
				align: this.DOM.path[0],
				alignOrigin: [0.5, 0.5],
			},
			...this.defaults,
		});
	}

	switchIndexes(bottom, middle, top) {
		gsap.set(bottom, { zIndex: 2 });
		gsap.set(middle, { zIndex: 3 });
		gsap.set(top, { zIndex: 4 });
	}

	createTimeline() {
		const tl = gsap.timeline({
			id: "scroll-plugins",
			repeat: -1,
			paused: true,
			scrollTrigger: {
				invalidateOnRefresh: true,
				trigger: this.DOM.wrap,
				once: true,
				start: "top bottom",
			},
		});

		tl.timeScale(1.6);

		tl.set(this.DOM.wrap, { autoAlpha: 1 });

		const mm = gsap.matchMedia();

		const backBallFront = () =>
			this.switchIndexes(this.DOM.back, this.DOM.ball, this.DOM.front);
		const backFrontBall = () =>
			this.switchIndexes(this.DOM.back, this.DOM.front, this.DOM.ball);
		const ballBackFront = () =>
			this.switchIndexes(this.DOM.ball, this.DOM.back, this.DOM.front);
		const frontBallBack = () =>
			this.switchIndexes(this.DOM.front, this.DOM.ball, this.DOM.back);

		mm.add(
			{
				isDesktop: "(min-width: 800px)",
				dontReduceMotion: "(prefers-reduced-motion: no-preference)",
			},
			(context) => {
				let { dontReduceMotion } = context.conditions;

				if (!dontReduceMotion) return;

				/* Animate */
				tl.add(this.ballAlongPath());
				tl.add(backFrontBall, 0.1);
				tl.add(backBallFront, 1.46);
				tl.add(ballBackFront, 3.7);
				tl.add(frontBallBack, 4.8);
				tl.add(backFrontBall, 5.03);
				tl.add(frontBallBack, 6.6);
				tl.add(ballBackFront, 8.44);
				tl.add(backBallFront, 9.8);
			}
		);

		return tl;
	}
}
